import Message from "../../message";
import {useMainStore} from "@/store";

export default class SaleDeleted extends Message
{
    handle()
    {
        useMainStore().DELETE_SALE(this.message.sale_id);
    }
}
